import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import discountRuleService from '../../service/discountRule.service';
import dayjs from 'dayjs';

export const DiscountRuleReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autocompleteOptions,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    discountRuleService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezése',
      type: 'string',
    },
    {
      field: 'percent',
      headerName: 'Százalék',
      type: 'string',
    },
    {
      field: 'priceListId',
      headerName: 'Árlista',
      type: 'singleSelect',
      valueOptions: autocompleteOptions?.priceList,
    },
    {
      field: 'customerId',
      headerName: 'Üp.',
      type: 'singleSelect',
      valueOptions: autocompleteOptions?.company,
    },
    {
      field: 'customerGroupId',
      headerName: 'Üp. csoport',
      type: 'singleSelect',
      valueOptions: autocompleteOptions?.companyGroup,
    },
    {
      field: 'itemCode',
      headerName: 'Cikk',
      type: 'singleSelect',
      valueOptions: autocompleteOptions?.item,
    },
    {
      field: 'itemGroupId',
      headerName: 'Cikkcsoport',
      type: 'singleSelect',
      valueOptions: autocompleteOptions?.itemGroup,
    },
    {
      field: 'validFrom',
      headerName: 'Kezdő dátum',
      type: 'date',
      sortable: false,
      valueGetter: (_data, row) => {
        return row.validFrom ? new Date(row.validFrom) : null;
      },
      renderCell: (data) => {
        return data.row.validFrom ? dayjs(data.row.validFrom).format('YYYY.MM.DD') : '';
      },
    },

    {
      field: 'validTo',
      headerName: 'Záró dátum',
      type: 'date',
      sortable: false,
      valueGetter: (_data, row) => {
        return row.validTo ? new Date(row.validTo) : null;
      },
      renderCell: (data) => {
        return data.row.validTo ? dayjs(data.row.validTo).format('YYYY.MM.DD') : '';
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.discountRuleTable}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default DiscountRuleReports;
